import { faFilePdf } from "@fortawesome/pro-light-svg-icons";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MultipleChoiceComponent = ({ element, questionIdMap, openPDF }) => {
  return (
    <div
      className="gradingFeedbackMultipleChoiceQuestionContainer"
      style={{
        backgroundColor:
          questionIdMap[element.questionId].EventName === "Answered Incorrectly"
            ? "#FFECEB"
            : "#F7FFED",
      }}
    >
      <div
        className="gradingFeedbackMultipleChoiceQuestionNumberWrapper"
        style={{
          backgroundColor:
            questionIdMap[element.questionId].EventName ===
            "Answered Incorrectly"
              ? "#B53333"
              : "#517145",
        }}
      >
        <h3 className="gradingFeedbackMultipleChoiceQuestionNumber">
          {element.questionNumber}
        </h3>
      </div>
      <div className="gradingFeedbackMultipleChoiceQuestionContentWrapper">
        <h4 className="gradingFeedbackMultipleChoiceQuestionTitle">
          {element.question.replaceAll("{input}", "_____")}
        </h4>
        {/* <div className='gradingFeedbackMultipleChoicePDFContainer'></div> */}
        {element.pdfFile && (
          <button
            className="openPDFButton"
            style={{ width: "fit-content", margin: 0, marginBottom: 10 }}
            onClick={() => openPDF(element.pdfBytes)}
          >
            <div className="openPDFIconWrapper">
              <FontAwesomeIcon icon={faFilePdf} className="openPDFButtonIcon" />
            </div>
            <span className="gradingFeedbackMultipleChoicePDFText">
              {element.pdfFile}
            </span>
          </button>
        )}
        {element.answerOptions.map((answer, answerIndex) => {
          let didUserSelectAnswer =
            questionIdMap[element.questionId].CustomerAnswer === answer.answer;
          let isAnswerCorrect =
            questionIdMap[element.questionId].CorrectAnswer === answer.answer;
          return (
            <div
              className="gradingFeedbackMultipleChoiceQuestionAnswerContainer"
              style={{
                backgroundColor:
                  didUserSelectAnswer && isAnswerCorrect
                    ? "#ECFFE5"
                    : didUserSelectAnswer && !isAnswerCorrect
                    ? "#FFECEB"
                    : "#F5F5F5",
              }}
            >
              <div
                className="gradingFeedbackMultipleChoiceQuestionCheckboxWrapper"
                style={{
                  backgroundColor:
                    didUserSelectAnswer && isAnswerCorrect
                      ? "#517145"
                      : didUserSelectAnswer && !isAnswerCorrect
                      ? "#B53333"
                      : "#6A6A6A",
                }}
              >
                <div className="gradingFeedbackMultipleChoiceQuestionCheckbox">
                  {didUserSelectAnswer && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="gradingFeedbackMultipleChoiceQuestionCheckboxIcon"
                    />
                  )}
                </div>
              </div>
              <div className="gradingFeedbackMultipleChoiceQuestionAnswerWrapper">
                <p className="gradingFeedbackMultipleChoiceQuestionAnswerText">
                  {answer.answer}
                </p>
                <p className="gradingFeedbackMultipleChoiceQuestionAnswerSubtext">
                  {answer.isCorrect ? "Correct Answer" : "Incorrect Answer"}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MultipleChoiceComponent;
